import React from 'react';
import iconregalo from 'assets/img/iconregalo.svg';
import styles from './styles.module.scss';

const ClosedTableMessage = () => (
  <div className={styles.ClosedTableMessage}>
    <img src={iconregalo} alt="" />
    <h2 className="title">¡Muchas gracias! El evento ha terminado</h2>
  </div>
);

export default ClosedTableMessage;
